import { Thumbnails } from '../../components/Thumbnails';
import { useOfferContext } from '../OfferContext';
import { useMemo } from 'react';

export const ThumbnailsContainer = () => {
  const { media, isPromoted } = useOfferContext();

  const thumbnails = useMemo(() => {
    if (!isPromoted || !media?.length) {
      return [];
    }

    return media.slice(1, 4).map(m => ({ previewUrl: m.previewUrl.replace(/-4\.jpg$/, '-2.jpg') }));
  }, [isPromoted, media]);

  if (!thumbnails.length) {
    return null;
  }

  return <Thumbnails media={thumbnails} />;
};
